export default __webpack_public_path__ + "static/media/082.1dddaddf.jpg";